import React, {useEffect, useState} from 'react';
import ReactsCard from "../components/ui/ReactsCard";
import {useOrganization, WithOrganization} from "../components/organizations/organization-context";
import {makeStyles} from '@material-ui/core/styles';
import OrganizationUnitTreeItem from '../components/organization-unit-tree/OrganizationUnitTreeItem';
import {useTranslation} from 'react-i18next';
import {useApiNotification} from "../components/ui/ApiNotificationProvider";
import {run} from "../utils/function-util";
import {useParams} from "react-router-dom";
import {getOrganizationUnit} from "../api/organization-unit-functions";
import {OrganizationUnit} from "../models/organization";
import {getOrganization} from "../api/organization-functions";

const useStyles = makeStyles(theme => ({
    root: {
        margin: theme.spacing(4)
    },
    tree: {
        marginTop: theme.spacing(2),
        display: 'flex',
        justifyContent: 'center'
    }
}));

const OrganizationUnits: React.FC<WithOrganization> = ({currentOrganization}) => {
    const classes = useStyles();
    const {organizationUnitId} = useParams<{ organizationUnitId: string }>();
    const {t} = useTranslation();
    const [,setOrganization] = useOrganization();
    const {handleError} = useApiNotification();
    let [orgUnit, setOrgUnit] = useState<OrganizationUnit>();

    useEffect(run(
        getOrganizationUnit(currentOrganization?.id ?? 1, parseInt(organizationUnitId as string)),
        setOrgUnit,
        handleError
    ), [organizationUnitId])

    const orgUnitEditHandler = async (unit: OrganizationUnit) => {
        // Refresh organization because renaming root unit affect the organization name
        if(unit?.level === 0) {
            await setOrganization(await getOrganization(unit.organizationId))
        }
    }

    return (
        <ReactsCard className={classes.root} title={t('OrganizationUnits.Title')}>
            <div>
                {t('OrganizationUnits.HelpMessage')}
            </div>
            <div className={classes.tree}>
                {
                    orgUnit ? <OrganizationUnitTreeItem
                        onUnitEdited={orgUnitEditHandler}
                        unit={orgUnit}
                        disableDelete
                    /> : null
                }
            </div>
        </ReactsCard>
    )
}

export default OrganizationUnits;
